// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateViewerAvatarMutation($input: UpdateViewerAvatarInput) {
    updateViewerAvatar(input: $input) {
      user {
        id
        avatar
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
